import { Check, Circle } from "lucide-react";
import { cn } from "@/lib/utils";

interface SetupProgressProps {
  managerSelected: boolean;
  reviewsConfirmed: boolean;
  csiCodesVerified: boolean;
  className?: string;
}

interface Step {
  id: string;
  label: string;
  complete: boolean;
}

export function SetupProgress({
  managerSelected,
  reviewsConfirmed,
  csiCodesVerified,
  className,
}: SetupProgressProps) {
  const steps: Step[] = [
    { id: "manager", label: "Manager assigned", complete: managerSelected },
    { id: "review", label: "Review times set", complete: reviewsConfirmed },
    { id: "csi", label: "CSI codes verified", complete: csiCodesVerified },
  ];

  const completedCount = steps.filter((s) => s.complete).length;
  const totalCount = steps.length;

  return (
    <div
      className={cn(
        "flex items-center gap-6 px-4 py-3 bg-muted/30 border rounded-sm",
        className
      )}
    >
      <div className="flex items-center gap-2 text-sm text-muted-foreground shrink-0">
        <span className="font-medium text-foreground">{completedCount}/{totalCount}</span>
        <span>complete</span>
      </div>
      <div className="flex items-center gap-4">
        {steps.map((step, index) => (
          <div key={step.id} className="flex items-center gap-2">
            {index > 0 && (
              <div
                className={cn(
                  "w-4 h-px",
                  steps[index - 1]?.complete ? "bg-primary" : "bg-muted-foreground/30"
                )}
              />
            )}
            <div className="flex items-center gap-1.5">
              {step.complete ? (
                <Check className="size-4 text-primary" />
              ) : (
                <Circle className="size-4 text-muted-foreground/50" />
              )}
              <span
                className={cn(
                  "text-sm",
                  step.complete
                    ? "text-foreground font-medium"
                    : "text-muted-foreground"
                )}
              >
                {step.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
